import { ArticleV1 } from '@ilteducation/content-registry-types';
import store from '@/store';
import mediaProvider from '@/data-provider/mediaProvider';

export const createAudio = async (article: ArticleV1, file: File) => {
  const response = await store.dispatch('audio-fragments/create', {
    data: {
      type: 'AudioFragmentV1',
      realm: 'se',
      sourceType: 'voice',
      key: `${article.id}_swe_plain_text`,
      language: 'swe',
    },
  });
  if (response.data.id) {
    await mediaProvider.uploadMedia(response.data.id, file);
    const data: any[] = [
      {
        op: 'replace',
        path: '/audio',
        value: {
          swe: {
            language: 'swe',
            audioFragmentId: response.data.id,
            sourceType: 'voice',
          },
        },
      },
    ];
    if (!article.isPublished) {
      data.push({
        op: 'replace',
        path: '/isPublished',
        value: true,
      });
    }
    await store.dispatch('articles/update', {
      id: article.id,
      data,
    });
  }
};
